import React, { useState } from 'react';
import api from '../utils/api';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import './styles/PaymentReportMonthlyPage.css';
import moment from 'moment';

const PaymentReportDailyPage = () => {
    const [reportDate, setReportDate] = useState('');
    const [report, setReport] = useState(null);

    const handleSearch = async () => {
        try {
            const response = await api.post('/report/payment/daily',
                {
                    data: [{
                        reportDate: reportDate
                    }]
                }
            );
            setReport(response.data.data);
    
        } catch (error) {
            console.error('Error fetching daily report:', error);
        }
    };


    const calculateReport = () => {
        const totals = {
            BCA: 0,
            BRI: 0,
            TOTAL: 0,
        };

        
        const paymentList = report?.paymentList || [];
        const classList = report?.classList || [];
        const publicClassList = report?.publicClassList || [];
    
        paymentList.forEach(detail => {
            switch (detail.Payment.payment_method) {
                case "BANK BCA":
                    totals.BCA += parseFloat(detail.payment_amount || 0);
                    totals.TOTAL += parseFloat(detail.payment_amount || 0);
                    break;
                case "BANK BRI":
                    totals.BRI += parseFloat(detail.payment_amount || 0);
                    totals.TOTAL += parseFloat(detail.payment_amount || 0);
                    break;
                default:
                    break;
            }
        });

        classList.forEach(detail => {
            switch (detail.payment_method) {
                case "BANK BCA":
                    totals.BCA += parseFloat(detail.payment_amount || 0);
                    totals.TOTAL += parseFloat(detail.payment_amount || 0);
                    break;
                case "BANK BRI":
                    totals.BRI += parseFloat(detail.payment_amount || 0);
                    totals.TOTAL += parseFloat(detail.payment_amount || 0);
                    break;
                default:
                    break;
            }
        });

        publicClassList.forEach(detail => {
            switch (detail.payment_method) {
                case "BANK BCA":
                    totals.BCA += parseFloat(detail.payment_amount || 0);
                    totals.TOTAL += parseFloat(detail.payment_amount || 0);
                    break;
                case "BANK BRI":
                    totals.BRI += parseFloat(detail.payment_amount || 0);
                    totals.TOTAL += parseFloat(detail.payment_amount || 0);
                    break;
                default:
                    break;
            }
        });
 
        return totals;
    };
    
    

    const formatCurrency = (amount) => {
        return parseFloat(amount).toLocaleString('id-ID', { minimumFractionDigits: 0 });
    };

    const exportPDF = () => {
        const reportContent = document.getElementById('reportContent');
        const reportTitle = `Income Daily Report Kidola - ${moment(reportDate).format('DD MMMM YYYY')}`;
        const pdf = new jsPDF();
    
        pdf.text(reportTitle, 10, 10); // Add the title at the top
    
        html2canvas(reportContent).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const imgWidth = 190; // PDF width in jsPDF
            const pageHeight = pdf.internal.pageSize.height;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            let heightLeft = imgHeight;
            let position = 20; // Adjust to leave space for the title
    
            pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
    
            while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }
    
            pdf.save(`Kidola_Daily_Report_${moment(reportDate).format('DD_MMMM_YYYY')}.pdf`);
        }).catch((error) => console.error('Error generating PDF:', error));
    };
    

    return (
        <div className="report-page">
            <div className="page-title">Kidola Daily Report</div>
            <div className="form-container">
                <div className="section">
                    <div className="search-container">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <label>Date Report</label>
                                </td>
                                <td>
                                    <input 
                                        type="date"
                                        name="reportDate"
                                        value={reportDate} 
                                        onChange={e => setReportDate(e.target.value)}
                                    />
                                </td>  
                            </tr>
                            <tr>
                                <td colSpan="2">
                                    <button onClick={handleSearch}>Search</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
                <div className="section">
                    <div id="reportContent">
                        {report && (
                            <>
                                <div className="students-list">
                                    <table>
                                        <thead>
                                            <th>Date</th>
                                            <th>Description</th>
                                            <th>Branch</th>
                                            <th>Payment Amount</th>
                                            <th>Payment Method</th>
                                        </thead>
                                        <tbody>
                                            {report.paymentList.map((payment, index) => (
                                                <tr key={payment.payment_detail_id}>
                                                    <td>{moment(payment.Payment.payment_date).format('DD MMMM YYYY')}</td>
                                                    <td>{payment.Inventory? 'Payment for '+payment.Inventory.item_name+' by '+payment.Payment.Student.student_name : 'Payment for '+payment.Cost.cost_item+' by '+payment.Payment.Student.student_name}</td>
                                                    <td>{payment.Payment.Branch?.branch_name || payment.Payment.Student.Branch.branch_name}</td>
                                                    <td>{payment.Payment.payment_method}</td>
                                                    <td className='table-right-align'>{formatCurrency(payment.payment_amount)}</td>
                                                </tr>
                                            ))}
                                            {report.classList.map((payment, index) => (
                                                <tr key={payment.payment_detail_id}>
                                                    <td>{moment(payment.payment_date).format('DD MMMM YYYY')}</td>
                                                    <td>{'Payment for '+payment.ClassHistory.Program.program_name+' by '+payment.Student.student_name}</td>
                                                    <td>{payment.Branch?.branch_name || payment.Student.Branch.branch_name}</td>
                                                    <td>{payment.payment_method}</td>
                                                    <td className='table-right-align'>{formatCurrency(payment.payment_amount)}</td>
                                                </tr>
                                            ))}
                                            {report.publicClassList.map((payment, index) => (
                                                <tr key={payment.payment_detail_id}>
                                                    <td>{moment(payment.payment_date).format('DD MMMM YYYY')}</td>
                                                    <td>{'Payment for '+payment.ClassHistory.Program.program_name+' by '+payment.PublicStudent.student_name}</td>
                                                    <td>{payment.Branch?.branch_name || payment.PublicStudent.Branch.branch_name}</td>
                                                    <td>{payment.payment_method}</td>
                                                    <td className='table-right-align'>{formatCurrency(payment.payment_amount)}</td>
                                                </tr>
                                            ))}
                                            <tr>
                                            <td colSpan="4"><strong>Total Income BCA</strong></td>
                                            <td className='table-right-align' ><strong>{formatCurrency(calculateReport().BCA)}</strong></td>
                                            </tr>
                                            <tr>
                                            <td colSpan="4"><strong>Total Income BRI</strong></td>
                                            <td className='table-right-align' ><strong>{formatCurrency(calculateReport().BRI)}</strong></td>
                                            </tr>
                                            <tr>
                                            <td colSpan="4"><strong>Grand Total Income</strong></td>
                                            <td className='table-right-align' ><strong>{formatCurrency(calculateReport().TOTAL)}</strong></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                
                            </>
                        )}
                    </div>
                    <div className="search-container">
                        {report && (
                            <button onClick={exportPDF} className="export-button">Export to PDF</button>
                        )}
                    </div>
                </div>
            </div>
            
        </div>
    );
};

export default PaymentReportDailyPage;
